import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AuthGuard from './auth/AuthGuard';
import { authRoles } from './auth/authRoles';
import Loadable from './components/Loadable';
import MatxLayout from './components/MatxLayout/MatxLayout';
//Masters






import CompanyRoutes from './views/Company/CompanyRoutes';
import UserRoutes from './views/User/UserRoutes';





const NotFound = Loadable(lazy(() => import('app/views/sessions/NotFound')));
const JwtLogin = Loadable(lazy(() => import('app/views/sessions/JwtLogin')));
const JwtRegister = Loadable(
	lazy(() => import('app/views/sessions/JwtRegister'))
);
const ForgotPassword = Loadable(
	lazy(() => import('app/views/sessions/ForgotPassword'))
);
// dashboard page
const Analytics = Loadable(lazy(() => import('app/views/dashboard/Analytics')));
const FinanceDashboard = Loadable(lazy(() => import('app/views/dashboard/FinanceDashboard')));
const AppointmentList = Loadable(lazy(() => import('app/views/dashboard/AppointmentList')));
const DoctorMaster = Loadable(lazy(() => import('app/views/Doctor/DoctorMaster')));
const ApiMaster = Loadable(lazy(() => import('app/views/Masters/ApiMaster')));
const ExpenseTransaction = Loadable(lazy(() => import('app/views/Expense/ExpenseTransaction')));
const PatientHistory = Loadable(lazy(() => import('app/views/Patient/PatientHistory')));
const TreatmentTransaction = Loadable(lazy(() => import('app/views/Treatment/TreatmentTransaction')));
const TreatmentView = Loadable(lazy(() => import('app/views/Treatment/TreatmentView')));
const TreatmentForm = Loadable(lazy(() => import('app/views/Treatment/TreatmentForm')));
const OperationsReport = Loadable(lazy(() => import('app/views/Reports/OperationsReport')));

const routes = [
	{
		element: (
			<AuthGuard>
				<MatxLayout />
			</AuthGuard>
		),
		children: [
			{
				path: '/dashboard/default',
				element: <Analytics />,
				auth: authRoles.admin,
			},
			{
				path: '/dashboard/finance',
				element: <FinanceDashboard />,
				auth: authRoles.admin,
			},
			{
				path: '/reports/finance',
				element: <FinanceDashboard />,
				auth: authRoles.admin,
			},
			{
				path: '/reports/treatments',
				element: <OperationsReport type="treatments" />,
				auth: authRoles.admin,
			},
			{
				path: '/reports/appointments',
				element: <OperationsReport type="appointments" />,
				auth: authRoles.admin,
			},
			{
				path: '/appointment/list',
				element: <AppointmentList />,
				auth: authRoles.admin,
			},
			{
				path: '/doctor/list',
				element: <DoctorMaster />,
				auth: authRoles.admin,
			},
			{
				path: '/medicine/list',
				element: <ApiMaster type="medicine" />,
				auth: authRoles.admin,
			},
			{
				path: '/service/list',
				element: <ApiMaster type="service" />,
				auth: authRoles.admin,
			},
			{
				path: '/expense-category/list',
				element: <ApiMaster type="expenseCategory" />,
				auth: authRoles.admin,
			},
			{
				path: '/treatment-heading/list',
				element: <ApiMaster type="dentalTreatment" />,
				auth: authRoles.admin,
			},
			{
				path: '/expense/list',
				element: <ExpenseTransaction />,
				auth: authRoles.admin,
			},
			{
				path: '/patient/list',
				element: <ApiMaster type="patient" />,
				auth: authRoles.admin,
			},
			{
				path: '/patient/:patientId/history',
				element: <PatientHistory />,
				auth: authRoles.admin,
			},
			{
				path: '/treatment/list',
				element: <TreatmentTransaction />,
				auth: authRoles.admin,
			},
			{
				path: '/treatment/:treatmentId/view',
				element: <TreatmentView />,
				auth: authRoles.admin,
			},
			{
				path: '/treatment/new',
				element: <TreatmentForm />,
				auth: authRoles.admin,
			},
			{
				path: '/treatment/:treatmentId/edit',
				element: <TreatmentForm />,
				auth: authRoles.admin,
			},
			
		

			...CompanyRoutes,			
			...UserRoutes,			
	
		],
	},

	// session pages route
	{ path: '/session/404', element: <NotFound /> },
	{ path: '/session/signin', element: <JwtLogin /> },
	{ path: '/session/signup', element: <JwtRegister /> },
	{ path: '/session/forgot-password', element: <ForgotPassword /> },

	{ path: '/', element: <Navigate to='/session/signin' /> },
	{ path: '*', element: <NotFound /> },
];

export default routes;
